import { render, staticRenderFns } from "./Neysla.vue?vue&type=template&id=0de247f9&"
import script from "./Neysla.vue?vue&type=script&lang=js&"
export * from "./Neysla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports